export default {
  methods: {
    isMixPanelEnabled() {
      return this.$nuxt.$config?.public?.ENABLE_MIXPANEL;
    },
    mixPanelInit() {
      // Add package mixpanel-browser to package.json
      if (!this.isMixPanelEnabled()) return;
      // console.log("mixpanel added");
      // window.mixpanel = require("mixpanel-browser");
      // mixpanel.init(this.$nuxt.$config.MIXPANEL_TOKEN, {
      //   debug: true,
      //   track_pageview: true,
      //   ignore_dnt: true,
      //   persistence: "localStorage"
      // });

      this.mixpanelSetIdentity();
    },
    mixpanelSetIdentity() {
      if (!this.isMixPanelEnabled()) return;
      console.log("mixpanel idenitfied");
      // if (!window.mixpanel) this.mixPanelInit();
      const id = this.$nuxt.$store?.state?.auth?.user?.id;
      // if (id) window.mixpanel.identify(id);
    },
    mixPanelTrackEvent(name = "", payload = {}) {
      if (!this.isMixPanelEnabled()) return;
      console.log("mixpanel event", name);
      // if (!window.mixpanel) this.mixPanelInit();
      // window.mixpanel.track(name, payload);
    },
    mixPanelTrackPageView() {
      if (!this.isMixPanelEnabled()) return;
      console.log("mixpanel pageview");
      // if (!window.mixpanel) this.mixPanelInit();
      // window.mixpanel.track_pageview();
    }
  }
};
